import React from 'react';
import { Typography, Grid } from '@mui/material';

const ReviewStep = ({
    eshopData,
    scraperConfig,
    authConfig,
    advancedSettings,
    categories
}) => {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mb: 1 }}>
                    E-shop Information
                </Typography>
                <Typography><strong>ID:</strong> {eshopData.eshop_id}</Typography>
                <Typography><strong>Name:</strong> {eshopData.name}</Typography>
                <Typography><strong>Base URL:</strong> {eshopData.base_url}</Typography>
                <Typography><strong>Catalog URL:</strong> {scraperConfig.catalog_url || 'Not specified'}</Typography>
                <Typography><strong>Main URL:</strong> {scraperConfig.url || 'Not specified'}</Typography>
                <Typography><strong>Status:</strong> {eshopData.status}</Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 1, mb: 1 }}>
                    Authentication Configuration
                </Typography>
                <Typography><strong>Login URL:</strong> {authConfig.login_url}</Typography>
                <Typography><strong>Username Field:</strong> {authConfig.username_field}</Typography>
                <Typography><strong>Password Field:</strong> {authConfig.password_field}</Typography>
                <Typography><strong>Login Button:</strong> {authConfig.login_button}</Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 1, mb: 1 }}>
                    Scraper Configuration
                </Typography>
                <Typography><strong>Type:</strong> generic</Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 1, mb: 1 }}>
                    Selector Configuration
                </Typography>
                {Object.entries(scraperConfig.selectors || {}).map(([key, value]) => (
                    <Typography key={key}>
                        <strong>{key}:</strong> {typeof value === 'object' && value !== null ? (value.selector || '') : value}
                    </Typography>
                ))}
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 1, mb: 1 }}>
                    Advanced Settings
                </Typography>
                <Typography><strong>Max Pages:</strong> {advancedSettings.pagination.max_pages}</Typography>
                <Typography><strong>Product Limit:</strong> {advancedSettings.testing.product_limit}</Typography>
                <Typography><strong>Testing Mode:</strong> {advancedSettings.testing.enabled ? 'Enabled' : 'Disabled'}</Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 1, mb: 1 }}>
                    Categories Configuration
                </Typography>
                {categories && categories.length > 0 ? (
                    categories.map((category, index) => (
                        <div key={index}>
                            <Typography><strong>Category {index + 1}:</strong></Typography>
                            <Typography>&nbsp;&nbsp;Name: {category.name}</Typography>
                            <Typography>&nbsp;&nbsp;Products URL: {category.products_url}</Typography>
                            <Typography>&nbsp;&nbsp;Category Default: {category.category_default}</Typography>
                        </div>
                    ))
                ) : (
                    <Typography>No categories configured</Typography>
                )}
            </Grid>
        </Grid>
    );
};

export default ReviewStep;